import { configureStore } from '@reduxjs/toolkit';
import authReducer from './auth/authSlice';
import editorReducer from './editor/editorSlice';
import gymReducer from './gym/gymSlice';
import contestReducer from './contest/contestSlice';
import assignmentReducer from './assignments/assignmentSlice';
import precourseReducer from './precourse/precourseSlice';
import sessionReducer from './session/sessionSlice';
import homescreenReducer from './homescreen/homescreenSlice';
import userReducer from './user/userSlice';
import moduleReducer from './modules/moduleSlice';
import courseReducer from './course/courseSlice';
import onevoneReducer from './onevone/onevoneSlice';
import projectsReducer from './projects/projectSlice';
import jobPortalReducer from './jobportal/jobPortalSlice';
import codeEditorSliceReducer from './codeEditorSlice/codeEditorSlice';
import {
	initMessageListener,
	createStateSyncMiddleware,
	initStateWithPrevTab,
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	//@ts-ignore
} from 'redux-state-sync';
import webDevQuestionReducer from './webDevQuestion/webDevQuestionSlice';
import { useDispatch } from 'react-redux';

const storeSync = configureStore({
	reducer: {
		auth: authReducer,
		user: userReducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware().concat(createStateSyncMiddleware()),
});

const store = configureStore({
	reducer: {
		auth: authReducer,
		user: userReducer,
		editor: editorReducer,
		gym: gymReducer,
		contest: contestReducer,
		assignment: assignmentReducer,
		precourse: precourseReducer,
		session: sessionReducer,
		homescreen: homescreenReducer,
		webDevQuestion: webDevQuestionReducer,
		module: moduleReducer,
		course: courseReducer,
		onevone: onevoneReducer,
		jobPortal: jobPortalReducer,
		projects: projectsReducer
	},
});

initStateWithPrevTab(storeSync);
export default store;

// For better usage with typescript
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
